module.exports = __webpack_public_path__ + "img/画板 3.85b3e3ed.png";